import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export type CompanyDetailTab = 'details' | 'users' | 'service-agreement';

export const useCompanyDetailTabs = () => {
  const { t } = useTranslation('ogp-screen-specific');
  const [selectedTab, setSelectedTab] = useState<CompanyDetailTab>('details');
  const tabs: { id: CompanyDetailTab; label: string }[] = [
    {
      id: 'details',
      label: t('collegial-lending.customers.detail.tabs.details.label', {
        defaultValue: 'Details',
      }),
    },
    {
      id: 'users',
      label: t('collegial-lending.customers.detail.tabs.users.label', {
        defaultValue: 'Gebruikers',
      }),
    },
    {
      id: 'service-agreement',
      label: t('collegial-lending.customers.detail.tabs.service-agreement.label', {
        defaultValue: 'Serviceovereenkomst',
      }),
    },
  ];

  return {
    selectedTab,
    selectTab: setSelectedTab,
    tabs,
  };
};
